import CheckBox from 'admin/components/atoms/CheckBox';
import Table from 'admin/components/atoms/Table';
import Pager from 'admin/components/shared/Pager';
import { formatDate, formatUUID } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CustomerListTable = ({
  receivers,
  onChangeCheckbox,
  onCheckAll,
  checkedIds,
  pagination,
  onChangePage,
}) => {
  const [allChecked, setAllChecked] = useState(false);

  useEffect(() => {
    setAllChecked(false);
  }, [receivers]);

  const handleCheckAll = (checked) => {
    setAllChecked(checked);
    onCheckAll(checked);
  };

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.Cell width="40px" align="center">
            <CheckBox
              style={{ margin: 5 }}
              setChecked={handleCheckAll}
              checked={allChecked}
              disabled={receivers.length <= 0}
            />
          </Table.Cell>
          <Table.Cell size="1">お客様ID</Table.Cell>
          <Table.Cell size="3">ニックネーム</Table.Cell>
          <Table.Cell size="2">携帯電話番号</Table.Cell>
          <Table.Cell>メールアドレス</Table.Cell>
          <Table.Cell size="1.5">会員登録日時</Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {receivers?.map((receiver) => (
          <Table.Row key={receiver.id}>
            <Table.Cell align="center">
              <CheckBox
                onChange={onChangeCheckbox}
                value={receiver.id}
                checked={checkedIds.includes(receiver.id)}
              />
            </Table.Cell>
            <Table.Cell wordBreak="keep-all">
              <Link to={`/customers/${receiver.id}`}>{formatUUID(receiver.id)}</Link>
            </Table.Cell>
            <Table.Cell wordBreak="break-word">{receiver.name}</Table.Cell>
            <Table.Cell>{receiver.tel}</Table.Cell>
            <Table.Cell wordBreak="break-word">{receiver.email}</Table.Cell>
            <Table.Cell styles={{ wordSpacing: '100vw' }}>
              {formatDate(receiver.registered_at)}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      {!!pagination && (
        <Table.Footer>
          <Table.Row noBorder>
            <Table.Cell colSpan={6} align="center" styles={{ paddingTop: '16px' }}>
              <Pager pagination={pagination} onChangePage={onChangePage} />
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

CustomerListTable.propTypes = {
  receivers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      tel: PropTypes.string,
      registered_at: PropTypes.string,
      last_transaction_at: PropTypes.string,
    })
  ),
  onChangeCheckbox: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
  checkedIds: PropTypes.array.isRequired,
};

CustomerListTable.defaultProps = {
  receivers: [],
};

export default CustomerListTable;
